import StatusDropDown from './StatusDropDown';

export default function RemarksStatusLine({
  remarks = '',
  status = '',
  onChange,
  remarksName = 'user_remarks',
  remarksId,
  statusName = 'status',
  statusDisabled = false,
}) {
  const id = remarksId || remarksName;
  return (
    <div className="remarks-status-line">
      <label htmlFor={id}>Remarks</label>
      <input
        type="text"
        id={id}
        name={remarksName}
        onChange={onChange}
        value={remarks || ''}
        maxLength={1000}
        placeholder="IF ANY"
        className="form-control remarks-status-input"
      />
      {statusName === 'status' ? (
        <StatusDropDown status={status} onChange={onChange} inline />
      ) : (
        <>
          <label htmlFor={statusName} className="product-status-label">Status </label>
          <select
            id={statusName}
            name={statusName}
            required
            disabled={statusDisabled}
            onChange={onChange}
            value={status || ''}
            className="browser-default custom-select form-control mandatory-form-control product-status-input"
          >
            <option value="true">Active</option>
            <option value="false">Inactive</option>
          </select>
        </>
      )}
    </div>
  );
}
